<template>
    <BillItem
        class="paid-line-item"
        :item="item"
        :quantityDigits="quantityDigits"
        :currentQuantity="props.item.paidQuantity"
        :totalQuantity="props.item.paidQuantity"
        :showInternalNames="props.showInternalNames"
        :allowDiscountRemoval="false"
        :showComment="false"
        :showOpenOrderDetailsButton="isUserWaiterOrAdmin"
        :forceDisplayGroupName="props.forceDisplayGroupName"
        :onClickOpenOrderDetails="props.onClickOpenOrderDetails"
    />
</template>

<script setup lang="ts">
    import { PaidLineItem } from "@/data/model/Bill";

    import BillItem from "@/components/order/BillItem.vue";

    // define properties
    const props = defineProps<{
        item: PaidLineItem;
        quantityDigits?: number;
        showInternalNames: boolean;
        forceDisplayGroupName?: boolean;
        isUserWaiterOrAdmin: boolean;
        onClickOpenOrderDetails: (orderId: string) => void;
    }>();
</script>
